import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { makeStyles, Theme } from '@material-ui/core'
import clsx from 'clsx'
import React, { FC, forwardRef, memo, ReactNode, useEffect } from 'react'
import { Handle } from './Handle'

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
    },
    dragging: {
        opacity: 0.75,
    },
}))
interface SortableItemProps {
    children: ReactNode
    className?: string
    dragOverlay?: boolean
    dragging?: boolean
    handle?: boolean
    handleProps?: any
    height?: number
    id: string
    onClick?: (...props: any) => void
    disabled?: boolean
    role?: string
}

const SortableItem: FC<SortableItemProps> = memo(
    forwardRef(
        (
            {
                dragOverlay,
                handle,
                handleProps,
                className,
                children,
                id,
                onClick,
                disabled,
                role,
            },
            ref
        ) => {
            const classes = useStyles()

            const {
                attributes,
                isDragging,
                listeners,
                setNodeRef,
                transition,
                transform,
            } = useSortable({ id })

            const style = {
                opacity: isDragging ? 0.5 : undefined,
                transform: CSS.Translate.toString(transform),
                transition,
            }

            useEffect(() => {
                if (!dragOverlay) {
                    return
                }

                document.body.style.cursor = 'grabbing'

                return () => {
                    document.body.style.cursor = ''
                    ref = null
                }
            }, [dragOverlay, ref])

            return (
                <>
                    <span
                        className={clsx(classes.container, className)}
                        ref={setNodeRef}
                        {...attributes}
                        {...(!handle && !disabled ? listeners : undefined)}
                        style={style}
                        role={role ?? 'span'}
                        onClick={onClick}
                        tabIndex={-1}
                    >
                        {handle ? (
                            <Handle
                                {...handleProps}
                                {...(!disabled && { ...listeners })}
                            />
                        ) : null}

                        {children}
                    </span>
                </>
            )
        }
    )
)

export default SortableItem
